module.exports = __webpack_public_path__ + "img/kv_4_1.c5fe5535.png";